import http from '../../shared/http.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { initLiveList } from '../../shared/liveList.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';
import { refreshBadge } from './aufgabenGlocke.js';

// The dashboard's task list: filtering, searching, paging, and the two actions
// each row carries.

export function initAufgabeList() {
  // `path: '/'` is a first here - every other list lives on its own segment.
  // liveList's dead-session guard still works: it compares the redirect's
  // pathname against this path, and '/login' is not '/'.
  const live = initLiveList({
    results: 'aufgabe-list',
    path: '/',
    forms: ['aufgabe-filter', 'aufgabe-search']
  });
  if (!live) return;

  // Anchored on /aufgaben/… rather than any href ending in /new or /edit: the
  // rows link out to /kunden/…, /jobs/… and /kandidaten/…, and an Öffnen link
  // must not be swallowed into the dialog.
  initFormModalLinks({
    selector: 'a[href^="/aufgaben/"][href$="/new"], a[href^="/aufgaben/"][href$="/edit"]',
    onSaved: async () => {
      await live.refresh();
      // A new task is one more unread, so the bell moves too.
      await refreshBadge();
    }
  });

  const list = document.getElementById('aufgabe-list');

  // One delegated listener for the whole region, so the rows that arrive with
  // each refreshed fragment are live without rebinding anything.
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action="erledigt"]');
    if (!button) return;

    const { id, erledigt } = button.dataset;

    // No confirmation: closing is reversible from the same row the moment it is
    // done, and a dialog in front of an undoable action is a dialog people learn
    // to click through.
    button.disabled = true;
    showLoading(erledigt === 'true' ? 'Wird erledigt …' : 'Wird wieder geöffnet …');

    try {
      await http.patch(`/aufgaben/${id}/erledigt`, { erledigt: erledigt === 'true' });

      // Refetch rather than reload: the row leaves or returns while the filters,
      // the search and the scroll position all stay put. The badge goes with it,
      // or the bell would keep counting a task this page has just closed.
      await Promise.all([live.refresh(), refreshBadge()]);
      hideLoading();
      notifySuccess(
        erledigt === 'true' ? 'Aufgabe wurde erledigt.' : 'Aufgabe wurde wieder geöffnet.'
      );
    } catch (err) {
      hideLoading();
      button.disabled = false;
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
